/** @format */

import {
	ProductReviewFilterState,
	ProductReviewState,
	ProductReviewUiState,
	ProductReviewsProsConsState
} from '../../model';

import { ActionReducerMap } from '@ngrx/store';
import { productReviewsFilterReducer } from './product-reviews-filter.reducer';
import { productReviewsProsConsReducer } from './product-reviews-pros-cons.reducer';
import { productReviewsReducer } from './product-reviews.reducer';
import { productReviewsUiReducer } from './product-reviews-ui.reducer';

export interface AppProductReviewState {
	productReviewsFilterState: ProductReviewFilterState;
	productReviewsProsConsState: ProductReviewsProsConsState;
	productReviewsState: ProductReviewState;
	productReviewsUiState: ProductReviewUiState;
}

export const productReviewReducers: ActionReducerMap<AppProductReviewState> = {
	productReviewsState: productReviewsReducer,
	productReviewsFilterState: productReviewsFilterReducer,
	productReviewsUiState: productReviewsUiReducer,
	productReviewsProsConsState: productReviewsProsConsReducer
};
